module.exports = __webpack_public_path__ + "static/media/plus.82fd0359.svg";